export default __webpack_public_path__ + "static/media/iPhone_coupon_wallet.4065eaa6.png";